const initialState = {
   isFetchingList: true,
   isFetchingByFilter: false,
   isFetchingNextPage: false,
   list: {
      data: [],
   },
   isFetchingCastMemberDetails: true,
};

export default initialState;
